import { Box, Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { getSvg } from '@/utils/get-svg';

interface DialogProtectedPdfProps {
  onClose: () => void;
  filesName: string[];
}

export const DialogProtectedPdf = ({
  onClose,
  filesName,
}: DialogProtectedPdfProps) => {
  return (
    <BaseDialog
      open
      onClose={onClose}
      title="Documentos protegidos por senha!"
      actionsComponent={
        <Button onClick={onClose} variant="contained" autoFocus>
          Entendi
        </Button>
      }
      icon={
        <Box
          component="img"
          src={getSvg('marketing_promotion.svg')}
          sx={{ width: 150 }}
        />
      }
    >
      <Stack spacing={2}>
        <Typography>
          Os documentos indicados abaixo estão protegidos por senha e por esse
          motivo não podemos aceitá-los.
        </Typography>
        <ul>
          {filesName.map((name, index) => (
            <li key={index}>
              <Typography>{name}</Typography>
            </li>
          ))}
        </ul>
        <Typography>
          Para continuar, envie o documento sem senha, ou a imagem do documento.
        </Typography>
      </Stack>
    </BaseDialog>
  );
};
